import action from 'utils/createAction';
import API from 'types/api';
import queryString from 'query-string';

export default {
  getStream: (id) => action(API.GET_STREAM, { video_id: id }),
  getStreamVirtual: (video_id, virtual_id, timestamp, callback) =>
    action(API.GET_STREAM_VIRTUAL, {
      video_id,
      virtual_id,
      timestamp,
      onSuccess: callback,
      onError: callback,
    }),
  getStreamExternal: (video_id, callback) =>
    action(API.GET_STREAM_EXTERNAL, {
      video_id,
      onSuccess: callback,
      onError: callback,
    }),
  getTranslate: () => action(API.GET_TRANSLATE),
  getConfiguration: (place) => action(API.GET_CONFIGURATION, { place }),
  getPaymentsSystem: () => action(API.GET_PAYMENTS_SYSTEM),
  getVideoInfo: (id, options = {}) => action(API.GET_VIDEO_INFO, { id, options }),
  getEpisodes: (id) => action(API.GET_EPISODES, { id }),
  getUser: (requestedOnStartup = false) => action(API.GET_USER, requestedOnStartup),
  getSubscriptionInfo: () => action(API.GET_SUBSCRIPTION_INFO),
  getVideoCollection: (id) => action(API.GET_VIDEO_COLLECTION, { id }),
  getUserHistory: (id) => action(API.GET_USER_HISTORY, id),
  getEpgTime: (onSuccess, onError) => action(API.GET_EPG_TIME, { onSuccess, onError }),
  getEpgCurrent: (query, onSuccess, onError) =>
    action(API.GET_EPG_CURRENT, { ...queryString.parse(query), onSuccess, onError }),
  getEpg: (query, onSuccess, onError) =>
    action(API.GET_EPG, { ...queryString.parse(query), onSuccess, onError }),
  getChannels: (onSuccess, onError) => action(API.GET_CHANNELS, { onSuccess, onError }),
  postAuth: (login, password, rememberMe) =>
    action(isSafari() ? API.POST_3RD_PARTY_AUTH : API.POST_AUTH, {
      login,
      password,
      rememberMe,
    }),
  /*
  //  Or it's really have a reason to logout via popup?
   postLogout: () => action(isSafari() ? API.POST_3RD_LOGOUT : API.POST_LOGOUT),
   */
  postLogout: () => action(API.POST_LOGOUT),
  postRegistration: (login, password, verificationCode, captcha) =>
    action(isSafari() ? API.POST_3RD_PARTY_REGISTRATION : API.POST_REGISTRATION, {
      login,
      password,
      captcha,
      verification_code: verificationCode,
    }),
  postRestore: (login, password, verificationCode, captcha) =>
    action(API.POST_RESTORE, {
      login,
      password,
      verification_code: verificationCode,
      captcha,
    }),
  postCardEncrypt: (data) => action(API.POST_CARD_ENCRYPT, data),
};

function isSafari() {
  return (
    navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
    navigator.userAgent.toLowerCase().indexOf('chrome') === -1
  );
}
